import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ClearAllFiltersButton,
  ToggleFilterButton,
} from '@/components/data-table-actions';
import { EMPLOYEE_EDIT_DEFAULT_PARAMS } from '@/shared/employee';
import { HR_FILTER_FORM_DEFAULT_PARAMS } from '@/shared/hr-requests';
import { removeObjectKeys } from '@/utils/utils';
import EmployeeHRDocumentsList from '../../_components/table/hr-documents-table/EmployeeHRDocumentsList';

const HR_FILTER_KEYS_KEPT = [
  'limit',
  'offset',
  'route',
  'company',
  'typeOfLeaveSelect',
];

/** HR documents of the employee, across the middle of the profile. */
export default function EmployeeDocumentsSection({
  employeeId,
  filterForm,
  setQueryParams,
  onOpenFilters,
}) {
  const { t } = useTranslation(['menus', 'tables']);

  const removeFilterKeys = useMemo(
    () => removeObjectKeys(EMPLOYEE_EDIT_DEFAULT_PARAMS, HR_FILTER_KEYS_KEPT),
    []
  );
  const handleFilterReset = useCallback(() => {
    setQueryParams(removeFilterKeys);
    filterForm.resetFields();
  }, [setQueryParams, removeFilterKeys, filterForm]);

  return (
    <section className="col-start-2 row-start-1 flex min-h-0 min-w-0 flex-col overflow-hidden rounded-[14px] bg-white">
      <div className="flex items-center justify-between gap-2 border-b border-zinc-200 px-4 py-3">
        <h2 className="m-0 text-base font-extrabold">
          {t('hrDocuments', { ns: 'menus' })}
        </h2>
        <div className="flex gap-2">
          <ToggleFilterButton
            label={t('filters', { ns: 'tables' })}
            onClick={onOpenFilters}
            defaultParams={HR_FILTER_FORM_DEFAULT_PARAMS}
          />
          <ClearAllFiltersButton
            label={t('clearAllFilters', { ns: 'tables' })}
            onReset={handleFilterReset}
            defaultParams={removeFilterKeys}
          />
        </div>
      </div>
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <EmployeeHRDocumentsList
          employeeId={employeeId}
          className="h-full min-h-0"
          wrapperClassName="flex h-full min-h-0 flex-col"
        />
      </div>
    </section>
  );
}
